import { DeleteForeverRounded } from '@mui/icons-material';
import { Box, Typography, alpha } from '@mui/material';
import { memo, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { removeCatalogItemActions } from 'features/removeCatalogItem/model/slices/RemoveCatalogItemSlice';
import { useAppDispatch } from 'shared/lib/hooks/useAppDispatch';
import { useInitialEffect } from 'shared/lib/hooks/useInitialEffect';

interface RemoveCatalogItemProps {
    isSingleItem?: boolean;
}

export const RemoveCatalogItem = memo(
    ({ isSingleItem }: RemoveCatalogItemProps) => {
        const { t } = useTranslation();
        const dispatch = useAppDispatch();

        useInitialEffect(() => {
            dispatch(removeCatalogItemActions.setIsSingle(isSingleItem));
        });

        useEffect(() => {
            dispatch(removeCatalogItemActions.setIsSingle(isSingleItem));
        }, [dispatch, isSingleItem]);

        const onShowDeleteDialog = () => {
            dispatch(removeCatalogItemActions.setShowDialog(true));
        };

        return (
            <Box
                onClick={onShowDeleteDialog}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                    gap: '4px',
                    padding: '6px 10px',
                    borderRadius: '4px',
                    '&:hover': {
                        backgroundColor: '#E8EEF6',
                    },
                }}
            >
                <DeleteForeverRounded
                    sx={(theme) => ({
                        fontSize: '2rem',
                        width: '20px',
                        height: '20px',
                        color: alpha(theme.palette.text.disabled, 0.6),
                    })}
                />
                <Typography
                    sx={(theme) => ({
                        color: alpha(theme.palette.text.disabled, 0.6),
                    })}
                    variant="subtitle2"
                >
                    {t('Remove')}
                </Typography>
            </Box>
        );
    },
);
